// extracted by mini-css-extract-plugin
export default {"top-right-actions":"StreamProvider_top-right-actions__Gfgg9","stream-ended":"StreamProvider_stream-ended__n27vy"};